import { Component, inject } from "@angular/core";
import { AsyncPipe } from "@angular/common";
import { LoaderComponent as TtLoaderComponent } from "@ticket-team-com/tt-component-library";
import { LoaderService } from "../services/loader.service";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.css"],
  imports: [AsyncPipe, TtLoaderComponent],
})
export class LoaderComponent {
  public loaderService = inject(LoaderService);
}
